import React, { useEffect, useState } from "react";

import { ChargeTable } from "./chargeTable";
import { Info } from "./info";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { fetchHcfDetails } from "./api";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { QualificationRateOverrides } from "./qualificationRateOverrides";
import { Qualification } from "@src/appV2/Admin/Qualifications/types";

interface TimeChargeProps {
  hcfId: string;
  hcfType: string;
  updateFacility: (data: unknown) => Promise<unknown>;
  qualifications: Qualification[];
}

function TimeCharge(props: TimeChargeProps): JSX.Element {
  const { hcfId, updateFacility, qualifications } = props;
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "ratesTable").then(setDetails).catch(setError);
  }, [hcfId]);

  const updateLocal = (data) => {
    setDetails((prev) => ({ ...prev, ratesTable: data.facility.ratesTable }));
  };

  const handleChange = (data) => {
    const [path] = Object.keys(data);
    const [day, slot] = path.split(".");
    updateFacility({
      facilityId: hcfId,
      ratesTable: {
        [day]: {
          [slot]: data[path],
        },
      },
    })
      .then(updateLocal)
      .catch(() => showErrorToast("Unable to update day/slot charge"));
  };

  return (
    <div>
      <ShowError error={error} message="Unable to fetch workplace Charge" />
      <Title>
        Shift Time Charge (added to HCF Base Charge for shifts with each time category)
        {/* @ts-expect-error FIXME this wrong type */}
        <Info
          text={
            <span>
              If a shift starts on these days /<br />
              times, the respective charge
              <br />
              will be added to the HCF Base
              <br />
              Charge.
            </span>
          }
        />
      </Title>
      <ChargeTable rates={details?.ratesTable} onChange={handleChange} />
      <QualificationRateOverrides
        hcfId={hcfId}
        qualifications={qualifications}
        updateFacility={updateFacility}
      />
    </div>
  );
}

export { TimeCharge };
